import { Controller } from '@hotwired/stimulus';
import Platform from '../../helpers/platform';
/**
 * A controller to handle comment submission when user presses Enter
 *
 * Targets:
 * - form: The comment form element
 * - input: The input field for the comment
 *
 * Usage:
 * <form data-controller="comments--create" data-comments--create-target="form">
 *   <textarea data-comments--create-target="input" data-action="keydown->comments--create#submitOnEnter"></textarea>
 * </form>
 */
export default class extends Controller {
  static targets = ['form', 'input', 'submitButton'];

  connect() {
    this.focusInput();
  }

  focusInput() {
    if (!Platform.isMobileDevice()) {
      this.inputTarget.focus();
    }
  }

  submitOnEnter(event) {
    // Submit form when Enter is pressed without Shift key
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();

      // Verify the form input is not empty before submitting
      const inputValue = this.inputTarget.value.trim();
      if (inputValue.length > 0) {
        this.submitButtonTarget.click();
      }
    }
  }
}
